
import { HyperLinkBuilder } from "widgets/commonComponents/inline/hyperLink"
import { HamburgerMenuItems } from "../../../../calcalistWidgets/categoryHeader/components/hamburgerMenuList/menuList";


interface MainNavProps {
    mainNavItems: HamburgerMenuItems[]
    openHam: () => void
    isAppNative?:boolean

}

export class MainNavMutam extends React.Component<MainNavProps, {}> {
    private getSelectedClassName = (isSelected: boolean) => {
        if (isSelected) {
            return "selected"
        }
    }
    render() {
        const { mainNavItems, openHam, isAppNative } = this.props


        return (
            <div className="mainNav" role="navigation" aria-label="Main Menu">
                          {!isAppNative && <button className="menuHamburger" onClick={openHam} />}
                <div className="navList">
                    {_.map((mainNavItems), (item: HamburgerMenuItems, index: number) => <div key={index} >
                        <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} className={this.getSelectedClassName(item.isSelected)}>
                            <span dangerouslySetInnerHTML={{ __html: item.title }} />
                        </HyperLinkBuilder>
                    </div>)}</div>
   
            </div>
        )
    }
}